import PropTypes from "prop-types";
import readXlsxFile from "read-excel-file";
import ExcelIcon from "../../assets/images/Excel-icon.png";
import { toast } from "react-toastify";
import UTILS from "../../utils";

const PartialImportExcel = ({ onFileReadSuccess, fileMapping }) => {
  const onFileChange = ({ target }) => {
    const options = {};
    if (fileMapping) {
      options.map = fileMapping;
      options.schema = UTILS.forms.studentExcelFileSchema;
    }

    readXlsxFile(target.files[0], options)
      .then((data) => {
        if (data?.rows.length > 500) {
          toast.error("Total Records must be lower than 500", {
            autoClose: 5000,
          });
          target.value = "";
        } else {
          onFileReadSuccess(data);
          document.getElementById("excelInput").value = null;
        }
      })
      .catch((err) => {
        console.log("Error", err);
        if (err.message.includes("A text for parsing must be a string.")) {
          console.log(err, err.message);
          toast.error(
            "File contains invalid mobile number format. Please use template for help."
          );
          document.getElementById("excelInput").value = null;
        } else {
          toast.error(
            "Invalid file type. Please try with valid excel file. You can download and edit our sample template for reference.",
            { autoClose: 5000 }
          );
          document.getElementById("excelInput").value = null;
        }
      });
  };

  return (
    <div className={"partials PartialImportExcel"}>
      <input
        type="file"
        accept={"application/xlsx"}
        name={"excelInput"}
        id={"excelInput"}
        onChange={onFileChange}
      />
      <div
        className={
          "flex justify-between gap-2 md:gap-6 items-center w-full flex-col md:flex-row md:w-4/5  bg-white mx-auto my-0 md:my-2 shadow rounded-lg  p-3 mb-6"
        }
      >
        <label
          className={"flex gap-4 items-center flex-1 cursor-pointer max-w-max"}
          htmlFor={"excelInput"}
        >
          <img src={ExcelIcon} className={"h-8 w-8"} alt="Phone icon" />
          <div className="flex gap-2 items-center">
            <span className={"text-center"}>Add to the class</span>
            <i className="icon icon-arrow-right text-2xl rotate-[270deg]"></i>
          </div>
        </label>
        <span className="hidden md:flex text-gray-400">|</span>
        <div className="w-full border-t flex md:hidden" />
        <a
          href={"/assets/sample-student-excel.xlsx"}
          download
          className={"flex"}
        >
          <span className="flex items-center text-red-500 underline decoration-solid mr-4">
            Download template
          </span>
          <i className="icon icon-download text-2xl"></i>
        </a>
      </div>
    </div>
  );
};

export default PartialImportExcel;

PartialImportExcel.propTypes = {
  onFileReadSuccess: PropTypes.func,
  fileMapping: PropTypes.object, // Mapper fo Excel file. It will map provided key with file header and will return JSON as output
};
